import { render } from "./TasksList.vue?vue&type=template&id=c2b56ada&scoped=true"
import script from "./TasksList.vue?vue&type=script&lang=js"
export * from "./TasksList.vue?vue&type=script&lang=js"

import "./TasksList.vue?vue&type=style&index=0&id=c2b56ada&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2b56ada"]])

export default __exports__